import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export const Content = /*#__PURE__*/_styled(props => {
  const {
    xs,
    sm,
    md,
    lg,
    xl,
    currentBreakpoint,
    ...restProps
  } = props;
  if (!props[currentBreakpoint]) {
    return null;
  }
  return _jsx("div", {
    ...restProps
  });
}, process.env.NODE_ENV === "production" ? {
  target: "eyt4ocw0"
} : {
  target: "eyt4ocw0",
  label: "Content"
})("grid-column:auto/last;&:first-of-type{grid-column-start:1;}grid-column-end:span ", props => props[props.currentBreakpoint], ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUUciLCJmaWxlIjoiQ29udGVudC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5leHBvcnQgY29uc3QgQ29udGVudCA9IHN0eWxlZCgocHJvcHMpID0+IHtcbiAgICBjb25zdCB7IHhzLCBzbSwgbWQsIGxnLCB4bCwgY3VycmVudEJyZWFrcG9pbnQsIC4uLnJlc3RQcm9wcyB9ID0gcHJvcHM7XG4gICAgaWYgKCFwcm9wc1tjdXJyZW50QnJlYWtwb2ludF0pIHtcbiAgICAgICAgcmV0dXJuIG51bGw7XG4gICAgfVxuICAgIHJldHVybiBfanN4KFwiZGl2XCIsIHsgLi4ucmVzdFByb3BzIH0pO1xufSkgYFxuICBncmlkLWNvbHVtbjogYXV0byAvIGxhc3Q7XG5cbiAgJjpmaXJzdC1vZi10eXBlIHtcbiAgICBncmlkLWNvbHVtbi1zdGFydDogMTtcbiAgfVxuXG4gIGdyaWQtY29sdW1uLWVuZDogc3BhbiAkeyhwcm9wcykgPT4gcHJvcHNbcHJvcHMuY3VycmVudEJyZWFrcG9pbnRdfTtcbmA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1Db250ZW50LmpzLm1hcCJdfQ== */"));